import * as _ from 'lodash';
import initialState from './initialState';
import { types } from './actions';
import { convertUTCDateStringToYYYYMMDDHHMMSSFormat } from '../../../HelperMethods/DateUtils';

function findDefaultOption(options) {
  let defaultOption = options.find((val) => val.isPlanned);
  if (!defaultOption) {
    [defaultOption] = options;
  }
  return defaultOption;
}

export default function manageMapViewReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADED_ROUTE_DATA_SUCCESSFULLY: {
      const { options } = action;
      const defaultOption = findDefaultOption(options);
      const runOptions = options.map((val) => {
        return {
          key: val.id,
          value: val.id,
          text: `${convertUTCDateStringToYYYYMMDDHHMMSSFormat(val.createdOn)} (${val.createdBy})`,
        };
      });
      return {
        ...state,
        routeData: { ...action.routeData, isLoading: false },
        runData: { runOptions, isLoading: false, defaultValue: defaultOption && defaultOption.id },
      };
    }
    case types.LOADED_ROUTE_DATA_FAILED: {
      return {
        ...state,
        routeData: { planned: null, actual: null, isLoading: false },
        runData: { runOptions: [], isLoading: false },
      };
    }
    case types.LOADING_ROUTE_DATA: {
      return {
        ...state,
        routeData: { ...state.routeData, isLoading: true },
        runData: { ...state.runData, isLoading: true },
      };
    }
    case types.LOADING_USERS_LOCATIONS: {
      return {
        ...state,
        usersLocationInfo: {
          users: [],
          isLoading: true,
        },
      };
    }
    case types.LOADED_USERS_LOCATIONS_FAILED: {
      return {
        ...state,
        usersLocationInfo: {
          users: [],
          isLoading: false,
        },
      };
    }
    case types.LOADED_USERS_LOCATIONS_SUCCESSFULLY: {
      const { users } = action;
      return {
        ...state,
        usersLocationInfo: {
          users,
          isLoading: false,
        },
      };
    }
    case types.LOADING_GEOFENCE_EVENTS: {
      return {
        ...state,
        geofenceEvents: {
          items: [],
          isLoading: true,
        },
      };
    }
    case types.LOADED_GEOFENCE_EVENTS_FAILED: {
      return {
        ...state,
        geofenceEvents: {
          items: [],
          isLoading: false,
        },
      };
    }
    case types.LOADED_GEOFENCE_EVENTS_SUCCESSFULLY: {
      const { items } = action;
      return {
        ...state,
        geofenceEvents: {
          items,
          isLoading: false,
        },
      };
    }
    case types.CLEAR_RUN_OPTIONS: {
      return { ...state, runData: { runOptions: [], isLoading: false, defaultValue: null } };
    }
    case types.LOADED_PLANNED_ROUTE_PARTICULAR_RUN_SUCCESSFULLY: {
      const { planned } = action;
      const routeData = _.cloneDeep(state.routeData);
      routeData.planned = planned;
      return { ...state, routeData: { ...routeData, isLoading: false } };
    }
    case types.LOADED_PLANNED_ROUTE_PARTICULAR_RUN_FAILED: {
      const routeData = _.cloneDeep(state.routeData);
      routeData.planned = { stops: [], locations: [] };
      return { ...state, routeData: { ...routeData, isLoading: false } };
    }
    case types.UPDATE_ACTUAL_ROUTE_DATA: {
      const { actual } = action;
      const routeData = _.cloneDeep(state.routeData);
      routeData.actual = actual;
      return { ...state, routeData: { ...routeData, isLoading: false } };
    }
    case types.LOAD_PLANNED_ROUTE_PARTICULAR_RUN: {
      return { ...state, routeData: { ...state.routeData, isLoading: true } };
    }
    case types.SET_STOP_DICT: {
      return { ...state, stopsDict: action.stopsDict };
    }
    case types.SELECT_STOP: {
      return { ...state, selectedStopId: action.stopId, isStopMarkerClicked: action.isStopMarkerClicked };
    }
    default:
      return state;
  }
}

export const findSelectedStopInfo = (stopId) => (state) => {
  const { stopsDict, routeData } = state.manageMapViewReducer;
  let stopInfo = stopsDict[stopId];
  if (!stopInfo) {
    // find stop info in routeData
    stopInfo =
      routeData.planned.stops.find((stop) => stop.stopId === stopId) ||
      routeData.actual.stops.find((stop) => stop.stopId === stopId);
  }
  return stopInfo;
};
